module.exports = __webpack_public_path__ + "static/media/buy.3e2c9521.png";